import React from "react";
import "./Contact.scss";
import Text from "./Text";

function Contact() {
 
  return (
    <div className="Contact" id="Contact">
      <div className="Contact-content">
        <Text/>
      </div>
    </div>
  )
}

export default Contact
